<template>
  <div>

  </div>
</template>

<script>
import bus from '@/assets/eventBus'
import g from '@/components/Global'
import GlobalConfig from '@/components/Global.config.vue'
  export default {
    data() {
      return {
        url: g.forwordTransactionServer,      //websocket地址
        typeGather: GlobalConfig.forwordMessageType,       //请求订阅类型数据
        positionData: [],     //期权持仓数据
        entrustData: [],      //期权委托数据
        mabData: [],      //期权成交数据
        settlePosition: [],      //期权盘前持仓

        socketPushWs: null,   //推送Websocket对象
        socketTimer: null,
        reconnectTimer: null,
        closeSign: null,

        closeTimer1: null,
        closeTimer2: null,

        initiativeClose: false,

        sub: null,
      }
    },
    created() {
      
    },
    destroyed() {
      this.cancelData()
    },
    methods: {
      beginData() {
        if(this.socketPushWs) return
        let initialize = this.typeGather.request
        let push = this.typeGather.push
        let messageTypes = [...Object.values(initialize), ...Object.values(push)]

        this.socketDataPush(messageTypes)
      },
      reconnect() {
        this.destorySocket()
        this.beginData()
      },
      destorySocket() {
        if(this.socketPushWs) {
          this.initialize = true      //主动关闭连接, 不重连
          this.socketPushWs.close()
          this.socketPushWs = null
        }
        if(this.socketTimer) {
          clearInterval(this.socketTimer)
          this.socketTimer = null
        }
        if(this.reconnectTimer) {
          clearTimeout(this.reconnectTimer)
          this.reconnectTimer = null
        }
      },
      cancelData() {
        return new Promise((reslove, reject) => {
          let cancel = Object.values(this.typeGather.cancel)
          if(!this.socketPushWs) return
          cancel.forEach(messageType => this.socketPushWs.send(JSON.stringify({messageType})))
          this.destorySocket()
          this.clearData()
          reslove()
        })
        
      },
      clearData() {
        this.positionData = []     //期权持仓数据
        this.entrustData = []      //期权委托数据
        this.mabData = []      //期权成交数据
        this.settlePosition = []      //期权盘前持仓
        this.clearShowData()      //情况界面显示的数据
      },
      clearShowData() {
        bus.$emit("clearForwordData")
      },
      reloadContract() {        
        let messageType = this.typeGather.request.requestContract
        this.socketPushWs.send(JSON.stringify({messageType}))
      },
      socketDataPush(messageTypes, cancel) {
        let url = this.url
        if(this.sub) url += '?subAccountNo=' + this.sub
        this.socketPushWs = new WebSocket(url)
        let _this = this
        this.socketPushWs.onopen = function(e) {
          messageTypes.forEach(messageType => {
            this.send(JSON.stringify({ messageType }))
          }) 
          _this.socketTimer = setInterval(() => {
            if(this.readyState !== 1) {
              return
            }
            this.send(JSON.stringify({messageType: "HEARTBEAT"}))
          }, 15000)
        }
        this.socketPushWs.onmessage = function(e) {
          let msg = JSON.parse(e.data)
          if(!msg.messageData || msg.messageData == 1) return
          let [name, data] = _this.discernName(msg.messageType, msg.messageData)
          _this[name] = data
          bus.$emit("forwordPsuh", [name, data])
        }
        this.socketPushWs.onerror = function(e) {
          if(_this.reconnectTimer) return
          _this.reconnectTimer = setTimeout(() => {
            _this.reconnect()
            _this.reconnectTimer = null
          }, 60000)  
        }
        this.socketPushWs.onclose = function(e) {
          if(_this.initialize) return       //主动关闭连接, 不重连
          if(_this.reconnectTimer) return
          if(_this.closeSign) {
             _this.closeTimer2 = setTimeout(() => {      //防抖, 在一秒钟之内关闭多次, 只执行一次
              _this.reconnect()
            }, 1000)
            return
          }
          _this.closeSign = true

          setTimeout(() => {      //防抖, 在一秒钟之内关闭多次, 只执行一次
            _this.closeSign = false
          }, 1000)

          _this.closeTimer1 = setTimeout(() => {
            _this.reconnect()
          }, 500)
        }
      },

      changeOfDay() {       //交易日变更, 清空之前数据, 重新获取初始化数据,
        // if(this.reconnectTimer) clearTimeout(this.reconnectTimer)      (交易日变更 取消订阅并重置储存数据, 重新开始请求(弃用该逻辑))
        // if(this.closeTimer1) clearTimeout(this.closeTimer1)
        // if(this.closeTimer2) clearTimeout(this.closeTimer2)
        // this.cancelData().then(() => {
        //   setTimeout(() => {
        //     this.beginData()
        //   }, 120000)
        // })

        this.clearData()
        setTimeout(() => {
          let initialize = this.typeGather.request
          let messageTypes = [...Object.values(initialize)]
          messageTypes.forEach(messageType => this.socketPushWs.send(JSON.stringify({messageType})))
        }, 30000)
      },

      discernName(messageType, messageData) {
        let arr = messageType.split("_")
        let name = arr[2]
        if(arr[1] === 'SETTLE') return ['settlePosition', messageData]
        if(name === 'DAY') return this.changeOfDay()      //交易日变更
        let dataName = ''
        switch(name) {
          case 'ORDER':
            dataName = 'entrustData'
            break;
          case 'TRADE':
            dataName = 'mabData'
            break;
          case 'CONTRACT':
            dataName = 'positionData'
            break;
        }
        if(arr.length > 3) {
          return [dataName, messageData]
        } else {
          if(name === 'ORDER') {        //当委托有平仓消息推送过来时, 重新请求一份持仓数据
            messageData.forEach(item => {
              if(item.openClose === 'C') this.reloadContract()
            })
          }
          return this.detectionPush(dataName, messageData)
        }
      },

      detectionPush(name, msg) {      //msg为推送过来的对象数组,name为储存该对象所用的对象名称
        msg.forEach(list => {
          let index = null
          this[name].forEach((item, i) => {
            if(item.contractNo === list.contractNo && item.orderNo === list.orderNo) {
              index = i.toString()
              this.$set(this[name], i, list)
            }
          })
          if(!index) this[name].unshift(list)
        })
        return [name, this[name]]
      },
    },
    watch: {
      $route: {
        handler(to, from) {
          if (to.path == '/newForword') {
            this.sub = to.query.sub
            let dis = to.query.dis
            if(dis) return
            this.reconnect()
          } else if(from.path === '/newForword' || from.path === '/newLayoutForword') {
            this.cancelData()
          }
        },
        immediate: true
      },
    },
  }
</script>

<style scoped>

</style>  